import AddAttachmentsButton from './AddAttachmentsButton';

export default AddAttachmentsButton;
